import styled, { css } from 'styled-components';

export const CalendarWrapper = styled.div`
  display: flex;
  flex-flow: column nowrap;
  flex: 0 0 auto;
  background-color: var(--background-secondary-color);
  color: var(--text-secondary-color);
  margin-bottom: 1em;
`;

export const CalendarTitle = styled.div`
  display: flex;
  flex-flow: row nowrap;
  flex: 1 0 auto;
  align-items: center;
  font-weight: 400;
  padding: 0 1em;
`;

export const CalendarTitleContent = styled.div`
  display: flex;
  flex-flow: column nowrap;
  flex: 1 0 auto;
`;

export const CalendarTitleIcon = styled.div`
  display: flex;
  align-items: center;
  margin-right: 0.5em;
`;

export const CalendarTitleActions = styled.div`
  display: flex;
  flex-flow: row nowrap;
  margin-left: auto;
  padding-left: 1rem;

  svg {
    stroke: var(--text-color);
  }

  > div + div {
    margin-left: 1rem;
  }
`;

export const CalendarContent = styled.div`
  display: grid;
  align-items: center;
  justify-items: center;
  gap: 0.25em;
  grid-template-columns: repeat(7, 1fr);
  grid-template-columns: repeat(7, 1fr);

  height: 0;
  visibility: hidden;
  opacity: 0;

  transition: all ease 0.3s;

  ${(props) => props.open
    && css`
      height: 320px;
      opacity: 1;
      padding-bottom: 0.5em;
      visibility: visible;
    `}
`;

export const CalendarCell = styled.div`
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: center;

  font-size: 0.8em;

  border: 1px solid transparent;
  border-radius: 500rem;

  height: 2.5rem;
  width: 2.5rem;

  ${(props) => props.available
    && css`
      border-color: var(--calendar-available-bg-color);
      background-color: ${props.active
    ? 'var(--calendar-selected-bg-color)'
    : 'var(--calendar-available-bg-color)'};
      color: ${props.active ? 'var(--calendar-selected-text-color)' : 'var(--text-color)'};
      font-weight: ${props.active ? 600 : 300};
    `};

  ${(props) => props.today
    && css`
      font-weight: 600;
    `};
`;

export const CalendarEventDotWrapper = styled.div`
  display: flex;
  flex-flow: row wrap;
`;

export const CalendarEventDot = styled.div`
  background-color: ${(props) => props.bgColor || 'var(--border-color)'};
  border-radius: 500rem;
  height: 3px;
  width: 3px;
  margin: 0.1em;
`;
